"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import renderIcon from "../../icons/render-icon.js";
import { makeStyles } from "../../theming/index.js";
import ButtonBase, { defaultShadows, paddings } from "../button-base/button-base.js";
import { ButtonGroupContext } from "./button-group.js";
function buttonGroupStyle(buttonGroup, { spacing }) {
    return buttonGroup
        ? {
            "position": "relative",
            "minWidth": "auto",
            "&:not(:disabled)": {
                boxShadow: "none",
            },
            "&:focus, &:active": {
                zIndex: 1,
            },
            "&:not(:first-child)": {
                marginLeft: `-${spacing(1)}`,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
            },
            "&:not(:last-child)": {
                borderRightColor: "transparent",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            },
        }
        : {};
}
const useStyles = makeStyles()((theme, { block, buttonGroup, isIconButton, size }) => ({
    button: Object.assign({ minWidth: isIconButton ? undefined : theme.size(80), width: !!block && !isIconButton ? "100%" : undefined }, buttonGroupStyle(!!buttonGroup, theme)),
    icon: {
        padding: size === "small" ? theme.size(1) : undefined,
        color: "inherit",
    },
    leftIcon: {
        marginRight: theme.spacing(paddings[size].x),
    },
    rightIcon: {
        marginLeft: theme.spacing(paddings[size].x),
    },
}));
export const Button = React.forwardRef(function Button(_a, ref) {
    var { block, children, className, color, icon, leftIcon, rightIcon, size, variant, shadow = defaultShadows[variant || "filled"] } = _a, props = __rest(_a, ["block", "children", "className", "color", "icon", "leftIcon", "rightIcon", "size", "variant", "shadow"]);
    const buttonGroupProps = useContext(ButtonGroupContext);
    const { classes, cx } = useStyles(Object.assign({ block, isIconButton: !!icon, size: size || buttonGroupProps.size || "medium" }, buttonGroupProps));
    return (_jsxs(ButtonBase, Object.assign({ ref: ref, className: cx(classes.button, className), color: color || buttonGroupProps.color || "primary", "data-component": "button", disabled: buttonGroupProps.disabled || props.disabled, shadow: shadow, size: size || buttonGroupProps.size || "medium", variant: variant || buttonGroupProps.variant || "filled" }, props, { children: [renderIcon(leftIcon, cx(classes.icon, classes.leftIcon)), icon ? renderIcon(icon, classes.icon) : _jsx("span", { children: children }), renderIcon(rightIcon, cx(classes.icon, classes.rightIcon))] })));
});
export default Button;
//# sourceMappingURL=button.js.map